export default __webpack_public_path__ + "bfa177abb4aafcb2f86633f041f7e5e2.png";